export default __webpack_public_path__ + "static/424-6522b578b11e508b0480535b56f25b85.gif";